<template>
  <div
    class="auth-page w-100 position-absolute bg-white"
    :style="{
      backgroundImage: `url(${require('@/assets/images/brief-bg.png')})`
    }"
  >
    <b-container class="p-0 h-100" fluid>
      <b-row align-h="center" class="h-100 no-gutters text-center">
        <b-col cols="12" sm="12" md="6" lg="8" class=" ">
          <div
            class="wrapper w-100 h-100 login-welcome auth-bg d-flex align-items-start p-5 justify-content-start text-center left-bg"
            :style="{ backgroundImage: bgImage }"
          ></div>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
          class="px-3  bg-no-repeat login-form"
        >
          <b-row class="h-100">
            <b-col cols="12" class="d-flex align-items-center w-100">
              <div class="wrapper w-100">
                <div class="form-wrapper px-2 px-md-5 mx-auto bg-auth-white">
                  <div class="heading-wrapper text-left">
                    <router-link to="/">
                      <img
                        :src="require('@/assets/icons/logo-dark.svg')"
                        height="75"
                        class="mt-2"
                        alt="Agbeloba Logo"
                      />
                    </router-link>
                    <h4
                      class="heading font-weight-bold text-black mb-1"
                      style="margin-top: 30px"
                    >
                      <i class="fa fa-lock"></i> Login
                    </h4>
                    <p>
                      Don't have an account?
                      <router-link to="/register">Register</router-link>
                    </p>
                  </div>
                  <b-form @submit="submit" @input="formInput" class="text-left">
                    <b-form-group
                      :invalid-feedback="formErrors.username"
                      :state="fieldState.username"
                    >
                      <b-form-input
                        id="username"
                        v-model="form.username"
                        placeholder="Email or Phone number"
                        :state="fieldState.username"
                        required
                        trim
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      :invalid-feedback="formErrors.password"
                      :state="fieldState.password"
                    >
                      <b-form-input
                        id="password"
                        v-model="form.password"
                        type="password"
                        required
                        aria-describedby="password-help-block"
                        placeholder="Password"
                      ></b-form-input>
                    </b-form-group>
                    <StatefulButton
                      :error="error"
                      :loading="submitting"
                      loadingText="Logging In..."
                      text="Log In"
                      elementClass="w-100"
                    />
                    <div class="text-right mt-2">
                      <router-link to="forgot-password" style="font-size:15px"
                        >Forgot password?</router-link
                      >
                    </div>
                  </b-form>
                </div>
                <div class="user-utils pt-3">
                  <div class="create-account"></div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validateRequired, checkFormErrors } from "@/utils/validators";

import StatefulButton from "@/components/actions/StatefulButton.vue";

export default {
  name: "Login-Page",
  components: {
    StatefulButton
  },
  data() {
    return {
      bgImage: `url(${require("@/assets/images/planters.png")})`,
      form: {
        username: "",
        password: ""
      },
      formErrors: {},
      submitting: false,
      error: false
    };
  },
  computed: {
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    ...mapActions("auth", ["login"]),

    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();

        await this.login({ ...this.form });
        const { next } = this.$route.query;
        if (next != null && next != "") this.$router.replace({ path: next });
        else this.$router.replace({ name: "dashboard" });
      } catch (err) {
        this.formErrors = err;
        this.submitting = false;
        this.error = true;
      }
    },
    validateForm() {
      const { errors, valid } = validateRequired(this.form);
      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    }
  },
  mounted() {
    // this.$drift.reset();
  }
};
</script>

<style lang="scss" scoped>
.login-welcome {
  background-size: 50%;
  background-position: left bottom;
  background-repeat: no-repeat;
  // background-position: right;
  position: relative;

  // &::before {
  //   content: "";
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.671), transparent);
  //   opacity: 0.5;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 1;
  // }
}

.login-form {
  background-position: left bottom;
  background-size: 50%;
}

.logo-text {
  text-shadow: 0px 1px 1px #555;
  font-family: "Roboto Slab", sans-serif;
  font-weight: 800;
  font-size: 70px;
  margin: 40px 0;
}

@media screen and (max-width: 768px) {
  .left-bg {
    background-position: center;
  }

  .mb-center {
    text-align: center !important;
  }
}

@media screen and (min-width: 769px) {
  .left-bg {
    background-position: center;
  }
}
</style>
